export const cleanUrls = url => {
  // clean urls to know how many people visit each of these pages
  url = url.replace(/users\/[0-9]+/g, 'users') // replace users/123123 -> users
  url = url.replace(/users\/me/g, 'users') // replace users/me -> users
  url = url.replace(/check\/[0-9]+/g, 'check') // replace check/123123 -> check

  return url
}
